export const EditPencilIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.99902 17.251V21.001H6.74902L17.809 9.94103L14.059 6.19104L2.99902 17.251Z' fill='currentColor' />
    <path
      d='M20.709 5.63104L18.369 3.29104C17.979 2.90104 17.349 2.90104 16.959 3.29104L15.129 5.12104L18.879 8.87104L20.709 7.04104C21.099 6.65104 21.099 6.02104 20.709 5.63104Z'
      fill='currentColor' />
  </svg>

)